import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { classSelector } from '../../../helpers/RoutesHelper';

const useStyles = makeStyles((theme) => ({
  button: {
    height: 52,
    fontSize: 17,
    '& .MuiButton-label': {
      justifyContent: 'flex-start',
      marginLeft: 20,
    },
    '&:hover': {
      backgroundColor: '#d9d9d9',
    },
    borderRadius: 0,
  },
  point: {
    color: theme.palette.primary.main,
    fontSize: 14,
    position: 'absolute',
    right: 20,
  },
  buttonActive: {
    height: 52,
    fontSize: 17,
    '& .MuiButton-label': {
      justifyContent: 'flex-start',
      marginLeft: 20,
    },
    '&.MuiButton-root': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      borderRadius: 0,
      '& span svg': {
        fill: 'white',
      },
    },
  },
  iconContainer: {
    height: 52,
    width: 52,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const GenericButtonGroup = ({ ...props }) => {
  const { group } = props;
  const classes = useStyles();
  const location = useLocation();

  const openOtherPage = (val) => {
    if (val.isRedirect) window.open(val.route);
  };

  return (
    <Box display="flex" flexDirection="column">
      {group.map((node) => (
        <React.Fragment key={node.id}>
          {!node.isRedirect ? (
            <Button
              variant="text"
              component={RouterLink}
              id={node.id}
              to={{
                pathname: node.route,
                state: { prevRoute: location.pathname },
              }}
              className={
                classSelector(location.pathname, node.route)
                  ? classes.buttonActive
                  : classes.button
              }
            >
              <div className={classes.iconContainer}>{node.icon}</div>
              {node.title}
              {node.isNew && <span className={classes.point}>¡Nuevo!</span>}
            </Button>
          ) : (
            <Button
              id={node.id}
              onClick={() => openOtherPage(node)}
              className={
                classSelector(location.pathname, node.route)
                  ? classes.buttonActive
                  : classes.button
              }
            >
              <div className={classes.iconContainer}>{node.icon}</div>
              {node.title}
              {node.isNew && <span className={classes.point}>¡Nuevo!</span>}
            </Button>
          )}

          <Divider />
        </React.Fragment>
      ))}
    </Box>
  );
};

GenericButtonGroup.propTypes = {
  group: PropTypes.array,
};

export default GenericButtonGroup;
